"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidQuoteId = void 0;
const utils_1 = require("@hc-frontend/utils");
/**
 * Returns true if the string is a valid quote id
 *
 * @public
 * @param {unknown} arg - A generic argument to check
 *
 * @returns {boolean}
 *
 * @example
 * ```ts
 * const result = isValidQuoteId('21321');
 * console.log(result);
 * // -> true
 * ```
 **/
function isValidQuoteId(arg) {
    return (0, utils_1.isString)(arg);
}
exports.isValidQuoteId = isValidQuoteId;
//# sourceMappingURL=is-valid-quote-id.js.map